import React, { useState, useEffect } from 'react'
import EmployeeCard from '../components/EmployeeCard'
import { useNavigate } from 'react-router-dom'
import EmployeeForm from '../components/EmployeeForm'
import * as api from '../utils/api/apiClient'
import { Loading } from '../components/Loading'
import { FcEmptyTrash } from 'react-icons/fc'
import { toast } from 'react-toastify'

function Employee() {
  const [loading, setLoading] = useState(false) // Manage loading state
  const navigate = useNavigate()
  const [showForm, setShowForm] = useState(false)
  const [allEmployees, setAllEmployees] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const [employeeId, setEmployeeId] = useState({})
  console.log(allEmployees)

  const handleNameClick = (id) => {
    navigate(`/employee/${id}`)
  }

  const handleAddEmployee = () => {
    setShowForm(true)
  }

  const handleCloseForm = () => {
    setShowForm(false)
  }

  const deleteEmployee = async (id) => {
    try {
      const res = await api.deleteEmployees(id)
      toast.success('Employee Deleted Successfully')
      fetchAllEmployee()
    } catch (error) {
      console.log(error)
    }
  }

  const fetchAllEmployee = async () => {
    try {
      const res = await api.getAllEmployees()

      setAllEmployees(res.data.employees)
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    fetchAllEmployee()
    setTimeout(() => {
      setLoading(true)
    }, 400) // 5 seconds
  }, [])

  return (
    <div>
      {!loading && <Loading />}
      <div className='relative bg-cream h-max p-2 '>
        <div className='flex justify-between'>
          <h1 className='text-2xl text-brown font-bold'>Employees</h1>
          <button
            onClick={handleAddEmployee}
            className='bg-tan p-2 text-white hover:bg-gold cursor-pointer rounded-md'
          >
            Add New Employee
          </button>
        </div>

        {allEmployees.length > 0 ? (
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 p-4'>
            {allEmployees?.map((employee, index) => (
              <div key={index}>
                <EmployeeCard
                  id={employee.work_id || 'NA'}
                  name={employee.name}
                  post={employee.post}
                  photo={employee.profile_pic}
                  email={employee.email}
                  phone={employee.phone_number}
                  joinDate={new Date(employee.created_at).toLocaleDateString()}
                  clicked={() => handleNameClick(employee.id)}
                  deleted={() => {
                    setEmployeeId(employee.id)
                    setIsOpen(true)
                  }}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className='col-span-full w-full my-8 bg-gradient-to-br from-cream to-beige rounded-lg border border-tan h-96 md:h-[500px] flex justify-center items-center'>
            <div className='text-center'>
              <FcEmptyTrash className='mx-auto h-16 w-16 md:h-24 md:w-24 text-red-500' />
              <p className='text-xl md:text-2xl text-brown mt-4'>
                Employee Not Fount !
              </p>
              <p className='text-base md:text-xl text-brown mt-2'>
                Something went wrong!
              </p>
            </div>
          </div>
        )}
        {/* ******************** */}
        {showForm && (
          <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50'>
            <div className='bg-cream w-full max-w-4xl mx-4 rounded-lg relative max-h-[90vh] flex flex-col'>
              <button
                onClick={handleCloseForm}
                className='absolute top-4 right-4 text-2xl font-bold text-gray-600 hover:text-gray-900 z-10'
              >
                &times;
              </button>
              <div className='p-6 md:p-8 overflow-y-auto flex-grow'>
                <EmployeeForm
                  onClose={handleCloseForm}
                  onSuccess={() => fetchAllEmployee()}
                />
              </div>
            </div>
          </div>
        )}
        {/* ****************** */}
        {isOpen && (
          <div className='fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm'>
            <div className='bg-white p-6 rounded-xl shadow-xl w-96 border border-gray-100'>
              <h2 className='text-xl font-bold text-black mb-4'>
                Confirm Deletion
              </h2>
              <p className='text-gray-600 mb-6'>
                Are you sure you want to delete employee record?
              </p>
              <div className='flex justify-end space-x-4'>
                <button
                  onClick={() => setIsOpen(false)}
                  className='px-4 py-2 bg-rust text-white rounded-lg hover:bg-gray-200 transition-colors'
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    deleteEmployee(employeeId)
                    setIsOpen(false)
                  }}
                  className='px-4 py-2 bg-tan text-white rounded-lg hover:bg-terracotta transition-colors'
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Employee
